import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import FlaggedDescriptionForm from "./flagged-description-form";
import FlaggedDescriptionData from "./flagged-description-data";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import React from "react";

const FlaggedDescriptions = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <FlaggedDescriptionForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <FlaggedDescriptionData />
    </React.Fragment>
  );
});
export default FlaggedDescriptions;
